
import { throttle } from 'throttle-debounce';
export default {
  data () {
    return {
    }
  },
  props: {
    position: {
      type: String,
      default: "flex"
    },
    info: {
      type: Object,
      default () {
        return {
          show: false,
          title: "",
          content: "",
          cancelBtnText: "Cancel",
          confirmBtnText: "OK",
          cancelBtnClick: () => { },
          confirmBtnClick: () => { },
          //按钮布局方向，默认横向，
          btnDirection: "Horizontal", //Horizontal 横向，VerticalReverse 垂直反向，
        }
      }
    }
  },
  methods: {
    btnCancel: throttle(1000, function () {
      this.info.cancelBtnClick && this.info.cancelBtnClick()
    }),
    btnConfirm: throttle(1000, function () {
      this.info.confirmBtnClick && this.info.confirmBtnClick()
    }),
  }
}
